import axiosInstance from "./AxiosInstance";

const API_URL = "/quizzes/myquizzes";
const QUIZ_API_URL = "/quizzes";
const MCQ_API_URL = "/mcqs";
const SUBMIT_QUIZ_RESULT = "/quizzes/myresult";
const STUDENTS = "/students";

export const getMyQuizzes = async (email = null) => {
  const url = email ? `${API_URL}?email=${email}` : API_URL;
  const response = await axiosInstance.get(url);
  return response.data;
};

export const getQuizById = async (quizId) => {
  const response = await axiosInstance.get(`${QUIZ_API_URL}/${quizId}`);
  return response.data;
};

export const getMcqById = async (mcqId) => {
  const response = await axiosInstance.get(`${MCQ_API_URL}/${mcqId}`);
  return response.data;
};

export const getStudentByUserId = async (userId) => {
  const response = await axiosInstance.get(`${STUDENTS}?userId=${userId}`);
  return response.data;
};

export const submitQuizAnswers = async (submissionData) => {
  const response = await axiosInstance.post(`${SUBMIT_QUIZ_RESULT}`, submissionData);
  return response.data;
};